<template>
  <div>
    <a-popover trigger="click" overlayClassName="input-passenger-wrapper" placement="bottom">
      <div style="position:relative;">
        <a-input class="input-passenger" size="large" v-model="message" read-only></a-input>
        <span class="arrow"></span>
      </div>
      <template slot="content">
        <div class="item-passenger" v-if="type === 'common'">
          <span class="label">成人（≥12岁）</span>
          <div class="input-number">
            <input-number v-model="ADT.num" :min="ADT.min" :max="ADT.max" @change="onADTChange"></input-number>
          </div>
        </div>
        <div class="item-passenger" v-if="type === 'common'">
          <span class="label">儿童（2岁(含)-12岁）</span>
          <div class="input-number">
            <input-number v-model="CNN.num" :min="CNN.min" :max="CNN.max" @change="onCNNChange"></input-number>
          </div>
        </div>
        <div class="item-passenger" v-if="type === 'common'">
          <span class="label">婴儿（14天(含)-2岁）</span>
          <div class="input-number">
            <input-number v-model="INF.num" :min="INF.min" :max="INF.max" @change="onINFChange"></input-number>
          </div>
        </div>
        <div class="item-passenger" v-if="type === 'jjc'">
          <span class="label">伤残军人</span>
          <div class="input-number">
            <input-number v-model="MWD.num" :min="MWD.min" :max="MWD.max" @change="onMWDChange"></input-number>
          </div>
        </div>
        <div class="item-passenger" v-if="type === 'jjc'">
          <span class="label">伤残人民警察</span>
          <div class="input-number">
            <input-number v-model="PWD.num" :min="PWD.min" :max="PWD.max" @change="onPWDChange"></input-number>
          </div>
        </div>
      </template>
    </a-popover>
  </div>
</template>
<script>
/**
 * 当前规则说明：1.旅客总数不能超过9；2.至少有一个成人旅客；3.成人旅客必须大于或等于婴儿旅客
 * 2021.08.19 版本更新规则说明：1.占座人数放开至9人（成人+儿童）；2.1名成人只能携带1名婴儿，1名成人最多携带3名儿童。
 * 2022.07.21 版本更新规则说明：1.1名满18周岁成人最多携带3名儿童（儿童+婴儿不可大于3），即1名满18周岁成人最多可携带2名儿童+1名婴儿，或最多携带3名儿童。2.当儿童+婴儿数量大于3时，提示：儿童数量超过限制，1名成人（年满18周岁）最多携带3名儿童（包括婴儿）。
 */

const airline = window.__MICRO_ROOT__?.airline
const seatMax = 9

// 成人与婴儿加儿童的比例关系
// NOTE: JD 和 UQ 特殊处理
let ratio = 3
const ratioMap = {
  UQ: 2,
  JD: 9,
  Y8: 9
}

// 最多儿童数量
let maxCNN = 6
const maxCNNMap = {
  JD: 8,
  Y8: 8
}

ratio = ratioMap[airline] ?? ratio
maxCNN = maxCNNMap[airline] ?? maxCNN

export default {
  name: 'input-passenger',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: Object,
    type: { // 类型，normal: 全部展示; common: 普通用户; jjc: 军警残
      type: String,
      default: 'common'
    }
  },
  data () {
    return {
      ADT: {
        num: 0,
        status: true,
        max: seatMax,
        min: 1,
        title: '成人'
      },
      CNN: {
        num: 0,
        status: true,
        max: 6,
        min: 0,
        title: '儿童'
      },
      INF: {
        num: 0,
        status: true,
        max: seatMax,
        min: 0,
        title: '婴儿'
      },
      MWD: {
        num: 0,
        status: true,
        max: 1,
        min: 0,
        title: '伤残军人'
      },
      PWD: {
        num: 0,
        status: true,
        max: 1,
        min: 0,
        title: '伤残人民警察'
      },
      message: '1成人，0儿童，0婴儿'
    }
  },
  watch: {
    type: {
      handler (newValue) {
        if (newValue) {
          this.init()
        }
      },
      immediate: true
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      const { ADT, CNN, INF, MWD, PWD } = this.value
      this.ADT.num = typeof ADT === 'undefined' ? 1 : ADT
      this.CNN.num = CNN || 0
      this.INF.num = INF || 0
      this.MWD.num = MWD || 0
      this.PWD.num = PWD || 0
      this.ADT.max = seatMax - this.CNN.num
      this.CNN.max = Math.min(seatMax - this.ADT.num, maxCNN)
      this.messageChange()
    },
    onADTChange (value) {
      const { ADT, CNN, INF, PWD, MWD } = this
      ADT.num = Math.min(value, ADT.max)
      if (value > 0) {
        MWD.num = 0
        PWD.num = 0
        ADT.min = 1
      }
      if (value < INF.num) {
        INF.num = value
      }
      if (Math.ceil((CNN.num + INF.num) / value) > ratio) {
        CNN.num = value * ratio - INF.num
      }
      ADT.max = seatMax - CNN.num
      INF.max = Math.min(seatMax - CNN.num, seatMax)
      CNN.max = Math.min(seatMax - ADT.num, maxCNN)
      this.change()
    },
    onCNNChange (value) {
      const { ADT, CNN, INF, PWD, MWD } = this
      CNN.num = Math.min(value, CNN.max)
      if (value > 0 && ADT.num === 0) {
        ADT.num = 1
        ADT.min = 1
        CNN.num = 1
        MWD.num = 0
        PWD.num = 0
      }
      if ((value + INF.num) > ADT.num * ratio && value + ADT.num < seatMax) {
        ADT.num++
      }
      ADT.max = seatMax - CNN.num
      INF.max = Math.min(seatMax - CNN.num, seatMax)
      CNN.max = Math.min(seatMax - ADT.num, maxCNN)
      this.change()
    },
    onINFChange (value) {
      const { ADT, CNN, INF, PWD, MWD } = this
      INF.num = Math.min(value, INF.max)
      if (value > 0 && ADT.num < value) {
        ADT.num = value
        ADT.min = 1
        MWD.num = 0
        PWD.num = 0
      }
      if ((value + CNN.num) > ADT.num * ratio && CNN.num + ADT.num < seatMax) {
        ADT.num++
      }
      ADT.max = seatMax - CNN.num
      INF.max = Math.min(seatMax - CNN.num, seatMax)
      CNN.max = Math.min(seatMax - ADT.num, maxCNN)
      this.change()
    },
    onMWDChange (value) {
      if (value > 0) {
        this.ADT.min = 0
        this.ADT.num = 0
        this.CNN.num = 0
        this.INF.num = 0
        this.PWD.num = 0
      } else if (this.PWD.num === 0) {
        this.ADT.min = 1
        this.ADT.num = 1
      }
      this.change()
    },
    onPWDChange (value) {
      if (value > 0) {
        this.ADT.min = 0
        this.ADT.num = 0
        this.CNN.num = 0
        this.INF.num = 0
        this.MWD.num = 0
      } else if (this.MWD.num === 0) {
        this.ADT.min = 1
        this.ADT.num = 1
      }
      this.change()
    },
    change () {
      this.messageChange()
      this.$emit('change', {
        ADT: this.ADT.num,
        CNN: this.CNN.num,
        INF: this.INF.num,
        MWD: this.MWD.num,
        PWD: this.PWD.num
      })
    },
    messageChange () {
      const { ADT, CNN, INF, MWD, PWD, type } = this
      const arrPassenger = type === 'common' ? [ADT, CNN, INF] : [MWD, PWD]
      let arrMessage = []
      arrPassenger.forEach(item => {
        if (item.num > 0) {
          arrMessage.push(item.num + item.title)
        } else {
          arrMessage.push(0 + item.title)
        }
      })
      this.message = arrMessage.join('，')
    }
  }
}
</script>

<style lang="less">
.input-passenger-wrapper {
  .arrow {
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    border-top: 7px solid #212529;
    position: absolute;
    right: 14px;
    top: 40%;
    width: 0;
  }

  .item-passenger {
    width: 280px;
    height: 45px;

    &:last-child {
      height: 30px;
    }

    .label {
      line-height: 30px;
      float: left;
    }
    .input-number {
      float: right;
    }
  }
}
</style>
